import { render, staticRenderFns } from "./CreateSimulation.vue?vue&type=template&id=25f85f8b&"
import script from "./CreateSimulation.vue?vue&type=script&lang=js&"
export * from "./CreateSimulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports